import AuthHelper from 'features/Auth/authHelper';
import { Navigate, useLocation } from 'react-router-dom';

// Route danh cho tai khoan chua dang nhap (Guest)
function GuestRoute(props) {
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const location = useLocation();

  // Cho phép vào reset password dù đã login
  const isResetPasswordPage =
    location.pathname === '/maintainer/auth/reset-password' &&
    location.search.includes('email=') &&
    location.search.includes('token=');

  // Nếu là trang reset password hợp lệ → cho vào
  // Ngược lại: nếu đã login → redirect về home
  if (isResetPasswordPage) {
    return props.children;
  }

  return !isAuth ? props.children : <Navigate to="/" replace />;
}

export default GuestRoute;